import React from "react";

export const LazySystemMonitorPage = React.lazy(
    () =>
        import(
            /* webpackChunkName: "SystemMonitorPage" */ "./SystemMonitorPage"
        )
);
